import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-illustrations.css';

const getClassNameList = classNames.bind(styles);
const EGDSIllustrations = (props) => {
    const { className, alt, url } = props;
    const cssClassNames = getClassNameList('uitk-illustration', className);
    return url ? jsx("img", { className: cssClassNames, alt: alt, src: url }) : null;
};
EGDSIllustrations.displayName = 'EGDSIllustrations';

export { EGDSIllustrations as E };
//# sourceMappingURL=index-chunk.esm.js.map
